import React, { useState } from 'react';
import { Table, InputNumber } from 'antd';
import styled from 'styled-components';
import PropTypes from 'prop-types';

function RiskIndicatorTable({
  riskIndicators,
  handleUserThreshold,
  typologyId,
  selectedCombinationId
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);

  const columns = [
    {
      title: <div>Risk Indicator</div>,
      width: '70%',
      render: (_, { name }) => <div>{name}</div>
    },
    {
      title: <div>Derived Threshold</div>,
      render: (_, { threshold }) => (
        <InputNumber disabled value={threshold?.value || 0} />
      ),
      width: '12%'
    },
    {
      title: <div>Final Threshold</div>,
      render: (_, { threshold }, index) => {
        return (
          <InputNumber
            value={threshold?.finalValue}
            onChange={(value) =>
              handleUserThreshold(
                typologyId,
                selectedCombinationId,
                (currentPage - 1) * pageSize + index,
                value
              )
            }
          />
        );
      },
      width: '12%'
    }
  ];

  const onPaginationChange = (page, newPageSize) => {
    setCurrentPage(page);
    setPageSize(newPageSize);
  };

  return (
    <>
      <StyledTable
        rowKey={({ name }) => name}
        columns={columns}
        dataSource={riskIndicators}
        pagination={{
          total: riskIndicators?.length,
          showTotal: (total) => `${total} Records`,
          pageSizeOptions: [5, 10, 25, 50, 100],
          current: currentPage,
          pageSize,
          onChange: onPaginationChange
        }}
      />
    </>
  );
}

const StyledTable = styled(Table)`
  font-size: 12px;
  margin-top: 15px;
  .ant-table-thead > tr > th {
    background: #ffffff;
    color: #748aa1;
    font-weight: 700;
    font-size: 12px;
    padding: 10px 12px;
  }
  .ant-table-cell {
    padding: 8px 12px;
    font-size: 12px;
    color: #31394d;
    border: 1px solid #d9d9d9d1;
  }
  .ant-input-number {
    border: 1px solid #d0d7e3;
    border-radius: 4px;
    font-size: 12px;
    width: 100%;
  }
  .ant-input-number-input {
    height: 20px;
  }
`;

RiskIndicatorTable.propTypes = {
  riskIndicators: PropTypes.array,
  handleUserThreshold: PropTypes.func,
  typologyId: PropTypes.number,
  selectedCombinationId: PropTypes.number
};

export default RiskIndicatorTable;
